export function propertyEqual(propertyDescriptor, objA, objB) {
    var property = propertyDescriptor.prop;
    var strict = propertyDescriptor.strict;

    if (property.includes(".")) {
        var properties = property.split(".");
        if (properties.length == 2 && strict) {
            if (!objA[properties[0]] && !objB[properties[0]])
                return true;

            if ((!objA[properties[0]] && objB[properties[0]]) || (objA[properties[0]] && !objB[properties[0]]))
                return false;

            return (
                objA[properties[0]][properties[1]] ===
                objB[properties[0]][properties[1]]
            );
        } else {
            return (
                objA[properties[0]][properties[1]] == objB[properties[0]][properties[1]]
            );
        }
    }
    if (strict) return objA[property] === objB[property];
    else return objA[property] == objB[property];
}

export function propertiesEqual(propertyDescriptors, objA, objB) {
    let inequalityDetected = propertyDescriptors.some(propDes => {
        return !propertyEqual(propDes, objA, objB);
    });

    return !inequalityDetected;
}

export function getValue(object, path) {
    return path.split('.').reduce((o, k) => (o || {})[k], object);
} 